import PlanificacionesContainer from '../components/PlanificacionesContainer'
import { PlanificacionesProvider } from '../providers/PlanificacionesProvider'

export default function PlanificacionesPage() {
  return (
    <PlanificacionesProvider>
      <PlanificacionesContainer />
    </PlanificacionesProvider>
  )
}
